import { createBusinessLogger } from '@/utils/logger/businessLogger';

// 事件名称常量
export const COMMON_EVENT_NAMES = {
  PAGE_ERROR_COMPONENT_SHOW: 'page_error_component_show',
  COMPONENT_MISS_RENDER: 'component_miss_render',
  COMPONENT_UNEXPECTED_RENDER: 'component_unexpected_render',
  JDI_PRICE_PARAMS_ERROR: 'jdi_price_params_error',
} as const;

// 导出类型定义，既可以当常量用也可以当类型用
export type EventNames = typeof COMMON_EVENT_NAMES;

export type PageName = 'dp';

// 暂时不需要分类，之后有需要再添加
const categoryNames: string[] = ['page'];

// 基础 Business Logger 实例 - 使用泛型约束事件名称
export const commonBusinessLogger = createBusinessLogger<EventNames>('common', categoryNames);
